import React from 'react';
import PropTypes from 'prop-types';

import content from '../../components/content/Content.m.sass';
import styles from './ErrorPage.m.sass';

import {connect} from 'react-redux';
import withMediaQueries from '../withMediaQueries/withMediaQueries';
import {fetchRootTaxonChildren} from '../../ducks/taxons';

import {Link} from 'react-router';

import Content from '../../components/content/Content';
import BreadcrumbsContainer from '../breadcrumbsContainer/BreadcrumbsContainer';
import Wysiwyg from '../../components/wysiwyg/Wysiwyg';
import GoBack from '../../components/goBack/GoBack';

const NOT_FOUND = 'not-found';
const SERVICE_UNAVAILABLE = 'service-unavailable';

@connect(({taxons}) => ({categories: taxons.root.children}))
@withMediaQueries({collapsed: '(max-width: 991px)'}, {collapsed: false})
export default class ErrorPage extends React.PureComponent {
  static notFound = NOT_FOUND;
  static serviceUnavailable = SERVICE_UNAVAILABLE;

  static propTypes = {
    type: PropTypes.oneOf([NOT_FOUND, SERVICE_UNAVAILABLE])
  };

  static defaultProps = {
    type: NOT_FOUND
  };

  componentDidMount() {
    const {dispatch, categories} = this.props;

    if (categories === undefined) {
      dispatch(fetchRootTaxonChildren());
    }
  }

  componentDidUpdate() {
    const {dispatch, categories} = this.props;

    if (categories === undefined) {
      dispatch(fetchRootTaxonChildren());
    }
  }

  render() {
    const {collapsed, type, categories, children} = this.props;

    return (
      <React.Fragment>
        {collapsed && (
          <GoBack />
        )}

        <Content>
          {!collapsed && (
            <div className={content.content_top}>
              <div className="container">
                <BreadcrumbsContainer only/>
              </div>
            </div>
          )}

          <div className="container">
            <div className={content.content_inner}>
              <div className={styles.errorPage}>
                {children || (
                  <React.Fragment>
                    <h1 className={content.content_header}>{type === NOT_FOUND
                      ? 'SORRY, PAGE NOT FOUND'
                      : 'AN UNEXPECTED ERROR OCCURRED'
                    }</h1>

                    {(!!categories && type === NOT_FOUND) && (
                      <Wysiwyg>
                        <p>Perhaps these links will help you out:</p>
                        <p>&nbsp;</p>

                        <ul>
                          <li>
                            <Link to="/">Homepage</Link>
                          </li>
                          {categories.map(category => (
                            <li key={category.id}>
                              <Link to={`/${category.slug}`}>{category.name} services</Link>
                            </li>
                          ))}
                        </ul>
                      </Wysiwyg>
                    )}
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </Content>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/errorPage/ErrorPage.js